




module.exports = {
  data: ->
    is_authorized: Session.authorized
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/old_reev.vue